export const instagramOnly = true;
export const shortRegistrationMode = true;